import { useContext, FC } from 'react';
import Link from 'next/link';

import { NavContext } from 'Context/nav-context';

import styles from './top-nav.module.scss';
import { formatLink } from '@/utils';
import { useDetermineBanner, useDetermineEnvironment } from '@/hooks';

interface INavigation {
  name: string;
  uid: string;
  link: string;
  hasChildren: boolean;
  child?: INavigation[];
}
interface ITopNav {
  navigation?: INavigation[];
}

const TopNav: FC<ITopNav> = ({ navigation }) => {
  const {
    category: {
      ['uid']: [uid, setUid],
    },
  } = useContext(NavContext);
  const isPhxBanner = useDetermineBanner();
  const env = useDetermineEnvironment();

  return (
    <nav data-testid="top-nav" title="Main Navigation" className={styles.topNavContainer}>
      <div className={styles.navHeaderLayout}>
        <ul className={styles.navItemsLayout}>
          {navigation?.map((item) => {
            const selectedNav = item.uid === uid ? styles.selectedNav : '';
            const italicNav = item.uid === 'FrontShopPCOptimumNavNode' ? styles.italic : '';
            return (
              <li className={`${styles.navItem} ${selectedNav} ${italicNav}`} key={item.uid} id={item.uid}>
                <Link
                  href={formatLink(item.link, isPhxBanner, env)}
                  onClick={() => {
                    setUid(item.uid);
                  }}
                  data-testid={item.uid}
                >
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default TopNav;
